import React from "react"

const PageNotFound = () => (
	<div className="app-body">
		<div className="container">
			<h1>404</h1>
			<p>Webinar not found</p>
		</div>
	</div>
)

export default PageNotFound;